<template>
  <div class="home">
    <van-swipe class="my_swipe" :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index" @click="onClick(index)">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>

    <div class="panel_header after_border">
      <div class="title">我加入的班级</div>
      <div v-if="is_leader" class="btn" @click="gotoClazzCreate">
        <van-icon name="plus" />新建班级
      </div>
    </div>

    <in-clazz-panel v-for="(item, index) in joinList" :key="index" :clazz="item.clazz" />
    <div class="no_clazz" v-if="noList">
      <div class="btn" @click="gotoExplore">还没有班级可以打卡，选择班级加入打卡</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swipe, SwipeItem, Icon } from 'vant'
import InClazzPanel from './components/InClazzPanel'
import BottomBtn from '@/components/BottomBtn'
import { joinClazzList } from '@/api/clazz'
import img1 from '@/assets/images/1.jpg'
import img2 from '@/assets/images/2.jpg'

export default {
  name: 'home',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    InClazzPanel,
    BottomBtn
  },
  data () {
    return {
      isLoaded: 0,
      joinList: [],
      images: [img1, img2],
      active: 0
    }
  },
  computed: {
    ...mapGetters([
      'userprofile',
      'is_leader'
    ]),
    noList () {
      return this.isLoaded && !this.joinList.length
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData () {
      let response = await joinClazzList({ not_ended: 1 })
      this.joinList = response.data
      this.isLoaded = 1
    },
    gotoClazzCreate () {
      if (!this.userprofile.is_bind_mobile) {
        this.$router.push('/bind/mobile?path=' + encodeURIComponent(this.$route.fullPath))
        return
      }
      this.$router.push('/manage/clazz/create')
    },
    gotoExplore () {
      this.$router.push('/explore')
    },
    onClick () {
      console.log(arguments)
    }
  }
}
</script>

<style lang="scss">
.panel_header {
  font-size: 26px;
  margin-top: 25px;
  padding-bottom: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 30px;
    width: 400px;
    margin-left: 20px;
    color: #333;
  }
  .btn {
    font-size: 26px;
    width: 160px;
    height: 55px;
    margin-right: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border: 1PX solid #ebedf0;
    border-radius: 8px;
    background-color: #f5222d;
  }
}
.no_clazz {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  .btn {
    width: 650px;
    height: 100px;
    font-size: 28px;
    background: #f5222d;
    color: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
